/**
 * AlertModal — نمایش هشدار/خطا به صورت modal وسط صفحه
 * با انیمیشن و دکمه بستن.
 */

import { useEffect } from 'react';

export default function AlertModal({ open, title, message, onClose }) {
    useEffect(() => {
        if (!open) return;

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleKeyDown);
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = '';
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="alert-modal-backdrop" onClick={onClose}>
            <div
                className="alert-modal"
                onClick={(e) => e.stopPropagation()}
                role="alertdialog"
                aria-modal="true"
            >
                <div className="alert-modal-icon">⚠️</div>
                <h3 className="alert-modal-title">{title || 'هشدار'}</h3>
                <p className="alert-modal-message">{message}</p>
                <button
                    type="button"
                    className="alert-modal-close-btn"
                    onClick={onClose}
                >
                    متوجه شدم
                </button>
            </div>
        </div>
    );
}